import { Button } from 'grommet'
import styled from 'styled-components'

const DangerButton = styled(Button)`
  background: #8E333E;
  color: white;
`

export default DangerButton